import React, {useEffect, useState} from 'react';
import {CSSTransition, TransitionGroup} from "react-transition-group";
import LinksPage from "./LinksPage";
import classnames from "classnames";
import LinksNavBar from "./LinksNavBar";

const defaultPageState = {
    activePage: 0,
    isForward: true
};

const LinksAppContainer = ({ pages, useIcons }) => {
    const componentClass = "linksAppContainer";
    const [pageState, setPageState] = useState(defaultPageState);
    const activePageIndex = pageState.activePage;
    const activePageObject = pages[activePageIndex] || {};

    useEffect(() => {
        window.scrollTo(0,0);
    }, [activePageIndex]);

    const onNavClick = (targetPage) => {
        let nextMoveIsForward = pageState.isForward;
        if (targetPage > pageState.activePage) {
            nextMoveIsForward = true;
        } else if (targetPage < pageState.activePage) {
            nextMoveIsForward = false;
        }
        setPageState({
            activePage: targetPage,
            isForward: nextMoveIsForward
        });
    }

    //TODO: refactor transition groups into react-app, similar to work in neuro
    const transitionClasses = classnames(
        `transition-for-${componentClass}`,
        {
            ['transition-from-right']: pageState.isForward,
            ['transition-from-left']: !pageState.isForward,
        },
        componentClass
    );

    //TODO: use props map for these
    const timeout = 750;
    const transitionTimeouts = {
        appear: timeout,
        enter: timeout,
        exit: timeout
    };

    return <div className={componentClass}>
        <LinksNavBar onClick={onNavClick} pages={pages} activePage={pageState.activePage} />
        <TransitionGroup>
            <CSSTransition key={pageState.activePage} classNames={transitionClasses} timeout={transitionTimeouts}>
                <LinksPage
                    pageIndex={pageState.activePage}
                    pageContent={activePageObject}
                    useIcons={useIcons}
                />
            </CSSTransition>
        </TransitionGroup>
    </div>;
};

export default LinksAppContainer;
